import Avatar from "avatar-initials";
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const initials = this.element.dataset.initials;
    Avatar.from(this.element, {
      useGravatar: false,
      initials: initials,
      color: "white",
      background: '#4B858E',
      fontWeight: 100,
      fontFamily: "Alegreya",
      fontSize: 18,
      width: 50,
      height: 50,
    });
  }
}
